import { render, staticRenderFns } from "./GroupFollowersAdmin.vue?vue&type=template&id=11ca6004&"
import script from "./GroupFollowersAdmin.controller.js?vue&type=script&lang=js&"
export * from "./GroupFollowersAdmin.controller.js?vue&type=script&lang=js&"
import style0 from "./GroupFollowersAdmin.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports